import { render, staticRenderFns } from "./SubSubComponent.vue?vue&type=template&id=87541268&scoped=true"
import script from "./SubSubComponent.vue?vue&type=script&lang=js"
export * from "./SubSubComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87541268",
  null
  
)

export default component.exports